// 企业微信相关配置
const workWeixin = {
  appid: 'ww3df55e9c78083062',
  redirect_uri: encodeURIComponent('https://cost.techjumper.com/wechat/callback')
}

const workWeixinAuthURL = `
https://open.weixin.qq.com/connect/oauth2/authorize?
appid=${workWeixin.appid}
&redirect_uri=${workWeixin.redirect_uri}
&response_type=code
&scope=snsapi_base
&state=STATE#wechat_redirect`

export {
  workWeixinAuthURL
}